import React from "react";

import { cn } from "../../../common/u1/cn";
import { CompanyMark } from "../../../common/u1/CompanyMark";
import { ChevronDown } from "../../../../assets/ui/icons";
import { ReactComponent as LogoSVG } from "../../../../assets/images/logo.svg";
import { FRAME, BAR } from "./editLayout";

/* The edit flow's own top bar. */
export const EditTopbar = ({
  company,
  companyId,
  onHome,
  onSaveExit,
  className = "",
}) => {
  const name =
    company?.registered_company_name || company?.name || "This company";

  return (
    <header
      className={cn(
        /* The token, not a literal: the working area's height is
           calc(100dvh - this), so the two must stay in step. */
        "h-[var(--edit-bar-h)] shrink-0 border-b border-[var(--line)] bg-white",
        className
      )}
    >
      {/* The bar's rule spans the viewport, but its contents sit on the same
          centred frame as the rail and the form — so the logo lines up with
          the rail and the account chip with the working area's edge. */}
      <div className={cn(FRAME, BAR, "flex h-full items-center justify-between gap-4")}>
      <button
        type="button"
        onClick={onHome}
        aria-label="TREVEX home"
        className="shrink-0 rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)]"
      >
        <LogoSVG className="h-[30px] w-auto" />
      </button>

      <div className="flex min-w-0 items-center gap-2 sm:gap-4">
        {/* Which company this flow is editing. Read-only: the live flow is
            entered per company and has no switcher, so this is a label. */}
        <div
          className={cn(
            "flex min-w-0 items-center gap-2.5 rounded-full border border-[var(--line)]",
            "bg-[var(--bg)] py-1.5 pl-1.5 pr-3.5 sm:pr-4"
          )}
        >
          {/* tone="brand" paints the one navy the design shows, rather than
              the hashed directory colour. */}
          <CompanyMark company={company || {}} size="xs" tone="brand" />
          <span className="flex min-w-0 flex-col">
            <span className="truncate text-[13px] font-bold leading-tight text-[var(--ink)] font-sans">
              {name}
            </span>
            {companyId && (
              <span className="truncate text-[11px] leading-tight text-[var(--muted-2)] font-mono">
                {companyId}
              </span>
            )}
          </span>
        </div>

        <button
          type="button"
          onClick={onSaveExit}
          className={cn(
            "flex shrink-0 items-center gap-2 rounded-lg px-2 py-2",
            "text-[13.5px] font-semibold text-[var(--ink-2)] font-sans",
            "transition-colors hover:bg-[var(--ghost-hover)]",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--coral)]"
          )}
        >
          {/* No dedicated left arrow in the shared set; the chevron rotated is
              the same mark. */}
          <ChevronDown size={12} className="rotate-90" />
          <span className="hidden sm:inline">Save &amp; exit</span>
          <span className="sr-only sm:hidden">Save and exit</span>
        </button>
        </div>
      </div>
    </header>
  );
};

export default EditTopbar;
